var dataMap = {
    informations: [
        {
            label: Loc.g('Nom'),
            id: 'name',
            format: 'text',
            favoriteName: 'informations_name',
            'data-bot': 'overview__general-info--name',
        },
        {
            label: Loc.g('Site web'),
            id: 'domain',
            format: 'external_url',
            favoriteName: 'informations_domain',
            'data-bot': 'overview__general-info--website',
        },
        {
            label: Loc.g('Téléphone'),
            id: 'phone',
            format: 'phone',
            favoriteName: 'informations_phone',
            'data-bot': 'overview__general-info--phone',
        },
        {
            label: Loc.g('Mobile'),
            id: 'mobile',
            format: 'phone',
            favoriteName: 'informations_mobile',
            'data-bot': 'overview__general-info--mobile',
        },
        {
            label: Loc.g('Fax'),
            id: 'fax',
            format: 'phone',
            favoriteName: 'informations_fax',
            'data-bot': 'overview__general-info--fax',
        },
        {
            label: Loc.g('Email'),
            id: 'email',
            format: 'email',
            favoriteName: 'informations_email',
            'data-bot': 'overview__general-info--email',
        },
        {
            label: Loc.g('Facebook'),
            id: 'facebook',
            format: 'external_url',
            favoriteName: 'informations_facebook',
            'data-bot': 'overview__general-info--facebook',
        },
        {
            label: Loc.g('Twitter'),
            id: 'twitter',
            format: 'external_url',
            favoriteName: 'informations_twitter',
            'data-bot': 'overview__general-info--twitter',
        },
        {
            label: Loc.g('Linkedin'),
            id: 'linkedin',
            format: 'external_url',
            favoriteName: 'informations_linkedin',
            'data-bot': 'overview__general-info--linkedin',
        },
        {
            label: Loc.g('Viadéo'),
            id: 'viadeo',
            format: 'external_url',
            favoriteName: 'informations_viadeo',
            'data-bot': 'overview__general-info--viadeo',
        },
    ],
    contacts: [
        {
            label: Loc.g('Contact principal'),
            id: 'fullName',
            format: 'link',
            favoriteName: 'contacts_fullName',
            'data-bot': 'overview__main-contact',
        },
        {
            label: Loc.g('Fonction'),
            id: 'position',
            format: 'text',
            favoriteName: 'contacts_position',
        },
        {
            label: Loc.g('Email'),
            id: 'email',
            format: 'email',
            favoriteName: 'contacts_email',
            'data-bot': 'overview__main-email',
        },
        {
            label: Loc.g('Téléphone'),
            id: 'phone',
            format: 'phone',
            favoriteName: 'contacts_phone',
            'data-bot': 'overview__main-phone',
        },
        {
            label: Loc.g('Mobile'),
            id: 'mobile',
            format: 'phone',
            favoriteName: 'contacts_mobile',
            'data-bot': 'overview__main-mobile',
        },
    ],
    financial: [
        {
            label: Loc.g('Compte tiers'),
            id: 'account',
            format: 'text',
            favoriteName: 'financial_account',
            'data-bot': 'overview__general-info--third-parties',
        },
        {
            label: Loc.g('Code compte auxiliaire'),
            id: 'auxiliaryCode',
            format: 'text',
            favoriteName: 'financial_auxiliaryCode',
            'data-bot': 'overview__general-info--subaccount-code',
        },
        {
            label: Loc.g('Catégorie tarifaire'),
            id: 'rateCategory',
            format: 'text',
            favoriteName: 'financial_rateCategory',
            'data-bot': 'overview__general-info--rate-category',
        },
        {
            label: Loc.g('N° TVA intracommunautaire'),
            id: 'vatNum',
            format: 'text',
            favoriteName: 'financial_vatNum',
            'data-bot': 'overview__general-info--vat',
        },
        {
            label: Loc.g('Référence'),
            id: 'reference',
            format: 'text',
            favoriteName: 'financial_reference',
            'data-bot': 'overview__general-info--reference',
        },
    ],
    legal: [
        {
            label: Loc.g('Forme juridique'),
            id: 'companyStatus',
            format: 'text',
            favoriteName: 'legal_companyStatus',
            'data-bot': 'overview__general-info--company-type',
        },
        {
            label: Loc.g('SIREN'),
            id: 'siren',
            format: 'text',
            favoriteName: 'legal_siren',
            'data-bot': 'overview__general-info--siren',
        },
        {
            label: Loc.g('SIRET'),
            id: 'siret',
            format: 'text',
            favoriteName: 'legal_siret',
            'data-bot': 'overview__general-info--siret',
        },
        {
            label: Loc.g('Code NAF'),
            id: 'ape',
            format: 'text',
            favoriteName: 'legal_ape',
            'data-bot': 'overview__general-info--ape-naf',
        },
        {
            label: Loc.g('RCS'),
            id: 'rcs',
            format: 'text',
            favoriteName: 'legal_rcs',
            'data-bot': 'overview__general-info--rcs',
        },
        {
            label: Loc.g('Capital social'),
            id: 'capital',
            format: 'text',
            favoriteName: 'legal_capital',
            'data-bot': 'overview__general-info--capital',
        },
    ],
};

var navMap = [
    {
        id: 'informations',
        label: '',
        items: [
            {
                id: 'activity',
                label: Loc.g('Activité'),
                group: false,
                component: 'tab-activity',
                permission: 'can_show_activity',
                keepalive: false,
                more: {},
            },
            {
                id: 'informations',
                label: Loc.g('Informations générales'),
                group: false,
                component: 'tab-informations-third',
                more: {},
            },
            {
                id: 'preferences',
                label: Loc.g('Préférences'),
                group: false,
                component: 'tab-preferences',
                more: {
                    buttons: [
                        {
                            type: 'function',
                            label: Loc.g('Editer'),
                            primary: true,
                            permission: 'can_edit',
                            event: 'edit',
                            params: {},
                        },
                    ],
                },
            },
            {
                id: 'financialactivity',
                label: Loc.g('Informations financières'),
                group: false,
                component: 'tab-financial-activity',
                more: {
                    buttons: [
                        {
                            label: Loc.g("Compléter via l'annuaire"),
                            callback: 'javascript: CompanySearch.modalUpdate({linkedid});',
                            permission: 'can_edit',
                            primary: true,
                        },
                    ],
                },
            },
            {
                id: 'contacts',
                label: Loc.g('Contacts associés'),
                group: false,
                component: 'tab-contacts',
                permission: 'can_show_contacts',
                more: {
                    buttons: [
                        {
                            label: Loc.g('Ajouter / Lier un contact'),
                            callback: "javascript:People.linkTo('third', {id});",
                            primary: true,
                        },
                    ],
                },
            },
            {
                id: 'addresses',
                label: Loc.g('Adresses'),
                group: false,
                component: 'tab-addresses',
                permission: 'can_show_addresses',
                more: {
                    buttons: [
                        {
                            id: 'add',
                            type: 'function',
                            label: Loc.g('Ajouter une adresse'),
                            primary: true,
                            permission: 'can_create_addresses',
                            event: 'openAddress',
                        },
                        {
                            id: 'seemap',
                            type: 'function',
                            label: Loc.g('Voir la carte'),
                            primary: false,
                            event: 'openAddressMap',
                            dataUpsell: 'map_listing',
                        },
                    ],
                },
            },
            {
                id: 'customfields',
                label: Loc.g('Champs personnalisés'),
                group: false,
                component: 'tab-customfields',
                more: {
                    url: '/rest/thirds/{linkedid}/custom-field-values',
                    buttons: [
                        {
                            type: 'function',
                            label: Loc.g('Editer'),
                            primary: true,
                            permission: 'can_edit',
                            event: 'openCustomfields',
                            params: {},
                        },
                    ],
                },
            },
            {
                id: 'statistics',
                label: Loc.g('Statistiques'),
                group: false,
                component: 'tab-statistics',
                more: {},
            },
        ],
    },
    {
        id: 'plugin',
        label: Loc.g('Modules'),
        items: [
            {
                id: 'opportunity',
                label: Loc.g('Opportunités'),
                group: false,
                component: 'tab-listing',
                permission: 'can_show_opportunity',
                more: {
                    linkedtype: 'opportunities',
                    name: 'lightened-opportunities',
                    url: '/prospection/opportunities',
                    title: Loc.g('Opportunités'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'function',
                            label: Loc.g('Créer une opportunité'),
                            primary: true,
                            permission: 'create',
                            url: {
                                event: 'openOpportunity',
                                params: {},
                            },
                        },
                    ],
                },
            },
            {
                id: 'estimate',
                label: Loc.g('Devis'),
                group: {
                    id: 'documents',
                    label: Loc.g('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_estimate',
                more: {
                    linkedtype: 'estimate',
                    name: 'lightened-saleestimates',
                    url: '/prospection/estimate',
                    title: Loc.g('Devis'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un devis'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_estimate',
                            href: "javascript:DocTools.createForThird('estimate', 'Créer un devis', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'invoiceDraft',
                label: Loc.g('Factures brouillon'),
                group: {
                    id: 'documents',
                    label: Loc.g('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_invoice',
                feature: 'numbering-draft',
                more: {
                    linkedtype: 'invoice',
                    name: 'lightened-saleinvoices-draft',
                    url: '/sales/invoice/draft',
                    title: Loc.g('Factures brouillon'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer une facture'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_invoice',
                            href: "javascript:DocTools.createForThird('invoice', 'Créer une facture', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'invoice',
                label: Loc.g('Factures'),
                group: {
                    id: 'documents',
                    label: Loc.g('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_invoice',
                more: {
                    linkedtype: 'invoice',
                    name: 'lightened-saleinvoices',
                    url: '/sales/invoice',
                    title: Loc.g('Factures'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer une facture'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_invoice',
                            href: "javascript:DocTools.createForThird('invoice', 'Créer une facture', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'delivery',
                label: Loc.g('Bon de livraison'),
                group: {
                    id: 'documents',
                    label: Loc.g('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_delivery',
                more: {
                    linkedtype: 'delivery',
                    name: 'lightened-saledeliveries',
                    url: '/prospection/delivery',
                    title: Loc.g('Bons de livraison'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un bon de livraison'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_delivery',
                            href: "javascript:DocTools.createForThird('delivery', 'Créer un bon de livraison', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'order',
                label: Loc.g('Bon de commande'),
                group: {
                    id: 'documents',
                    label: Loc.g('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_order',
                more: {
                    linkedtype: 'order',
                    name: 'lightened-saleorders',
                    url: '/prospection/order',
                    title: Loc.g('Bons de commande'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un bon de commande'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_order',
                            href: "javascript:DocTools.createForThird('order', 'Créer un bon de commande', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'creditnoteDraft',
                label: Loc.g('Avoir brouillon'),
                group: {
                    id: 'documents',
                    label: Loc.g('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_creditnote',
                feature: 'numbering-draft',
                more: {
                    linkedtype: 'creditnote',
                    name: 'lightened-salecreditnotes-draft',
                    url: '/prospection/creditnote/draft',
                    title: Loc.g('Avoirs brouillon'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un avoir'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_creditnote',
                            href: "javascript:DocTools.createForThird('creditnote', 'Créer un avoir', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'creditnote',
                label: Loc.g('Avoir'),
                group: {
                    id: 'documents',
                    label: Loc.g('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_creditnote',
                more: {
                    linkedtype: 'creditnote',
                    name: 'lightened-salecreditnotes',
                    url: '/prospection/creditnote',
                    title: Loc.g('Avoirs'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un avoir'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_creditnote',
                            href: "javascript:DocTools.createForThird('creditnote', 'Créer un avoir', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'proforma',
                label: Loc.g('Facture proforma'),
                group: {
                    id: 'documents',
                    label: Loc.g('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_proforma',
                more: {
                    linkedtype: 'proforma',
                    name: 'lightened-saleproformas',
                    url: '/prospection/proforma',
                    title: Loc.g('Factures proforma'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer une facture proforma'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_proforma',
                            href: "javascript:DocTools.createForThird('proforma', 'Créer une facture proforma', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'payments',
                label: Loc.g('Règlements'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_payments',
                more: {
                    title: Loc.g('Règlements'),
                    listingname: 'payments',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Ajouter un règlement'),
                            permission: true,
                            callback: "javascript:Payment.edit('', {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'bankaccount',
                label: Loc.g('Comptes & Cartes bancaires'),
                group: false,
                component: 'tab-account-credit-card',
                permission: 'can_edit',
                more: {
                    title: Loc.g('Comptes & Cartes bancaires"'),
                    buttons: [],
                },
            },
            {
                id: 'recurring',
                label: Loc.g('Abonnements'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_recurring',
                more: {
                    title: Loc.g('Abonnements'),
                    listingname: 'recurring',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un abonnement'),
                            permission: 'can_create_recurring',
                            callback: 'DocRecurring.editRecurring(0, {linkedid});',
                        },
                    ],
                },
            },
            {
                id: 'mandates',
                label: Loc.g('Mandats'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_mandates',
                more: {
                    title: Loc.g('Mandats'),
                    listingname: 'mandates',
                    url: '/?_f=gocardless_mandates',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Importer des mandats'),
                            permission: true,
                            callback: 'GoCardless.importPopup({linkedid});',
                        },
                        {
                            type: 'vuejs',
                            primary: true,
                            label: Loc.g('Inviter à la prise de mandat'),
                            permission: 'can_show_mandates',
                            event: 'sendemail',
                        },
                    ],
                },
            },
            {
                id: 'timetracking',
                label: Loc.g('Timetracking'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_timetracking',
                more: {
                    title: Loc.g('Timetracking'),
                    listingname: 'timetracking',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer une entrée'),
                            permission: true,
                            callback:
                                "javascript:TimetrackingEntry.edit('', '', '', '', {linkedid});",
                        },
                    ],
                },
            },
            {
                id: 'tickets',
                label: Loc.g('Support'),
                group: false,
                component: 'tab-2-columns',
                permission: 'can_show_tickets',
                more: {
                    title: Loc.g('Support'),
                    url: '/?_f=support_tickets',
                    action: 'loadThirdTab',
                    thirdid: '{linkedid}',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un ticket'),
                            permission: 'can_create_ticket',
                            callback: 'javascript:Ticket.add({linkedid});',
                        },
                    ],
                },
            },
            {
                id: 'project',
                label: Loc.g('Projets'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_project',
                more: {
                    title: Loc.g('Projets'),
                    listingname: 'project',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un projet'),
                            permission: 'can_create_project',
                            callback: 'javascript:project.projectForm();',
                        },
                    ],
                },
            },
            {
                id: 'proposal',
                label: Loc.g('Documents redactor'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_proposal',
                more: {
                    title: Loc.g('Documents redactor'),
                    listingname: 'proposal',
                    url: '/?_f=tabs',
                    action: 'loadListingTab',
                    context: 'third',
                    prefilter: '{"third": {linkedid}}',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un document redactor'),
                            permission: 'can_create_proposal_document',
                            callback: "javascript:Proposal.create('propdocument');",
                        },
                    ],
                },
            },
            {
                id: 'emailingprofile',
                label: Loc.g('Profil emailing'),
                group: {
                    id: 'mailinglist',
                    label: Loc.g('Mailing lists'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_mailinglist',
                more: {
                    tabType: 'total',
                    callbackKeyName: 'massMailingProfile',
                    title: Loc.g("Profil d'emailing"),
                    listingname: '',
                    url: '/?_f=massmailing_ajax',
                    action: 'loadMassMailingContactProfile',
                    type: 'corporation',
                    id: '{linkedid}',
                    buttons: [],
                },
            },
            {
                id: 'massmailingMailingList',
                label: Loc.g('Mailing lists'),
                group: {
                    id: 'mailinglist',
                    label: Loc.g('Mailing lists'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_mailinglist',
                more: {
                    title: Loc.g('Mailing lists'),
                    listingname: 'massmailingMailinglist',
                    url: '/?_f=massmailing_ajax',
                    action: 'loadMassMailingContactListingTab',
                    type: 'third',
                    id: '{linkedid}',
                    buttons: [],
                },
            },
            {
                id: 'massmailingCampaignList',
                label: Loc.g('Liste des campagnes'),
                group: {
                    id: 'mailinglist',
                    label: Loc.g('Mailing lists'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_mailinglist',
                more: {
                    title: Loc.g('Liste des campagnes'),
                    listingname: 'massmailingCampaignList',
                    url: '/?_f=massmailing_ajax',
                    action: 'loadMassMailingContactListingTab',
                    type: 'corporation',
                    id: '{linkedid}',
                    buttons: [],
                },
            },
            {
                id: 'receipts',
                label: Loc.g('Caisse'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_receipts',
                more: {
                    title: Loc.g('Caisse'),
                    listingname: 'receipts',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [],
                },
            },
            {
                id: 'briefcase',
                label: Loc.g('Fichiers'),
                group: false,
                component: 'tab-briefcase',
                permission: 'can_show_briefcase',
                more: {
                    title: '',
                    url: '/?_f=briefcasev2',
                    action: 'loadBriefcaseTab',
                    linkedid: '{linkedid}',
                    linkedtype: '{linkedtype}',
                    linkedtypeDir: 'thirds',
                    linkedname: '{linkedname}',
                    editpermission: 'editclient',
                    buttons: [],
                },
            },
        ],
    },
];

// SELLSYADMIN
// - Common tabs for SAM & SellsyAdmin
var sellsyAdminCommonTabs = [
    {
        id: 'samHistory',
        label: Loc.g('Histo actions admin'),
        group: {
            id: 'sam',
            label: Loc.g('SAM'),
        },
        component: 'tab-listingv1',
        permission: 'can_edit',
        more: {
            tabType: 'total',
            callbackKeyName: 'logs',
            title: '',
            listingname: '',
            url: '/?_f=logs',
            action: 'loadTab',
            relatedtype: 'sellsyadmin',
            relatedid: '{linkedid}',
            buttons: [],
        },
    },
    {
        id: 'samPlugins',
        label: Loc.g('Modules et crédits'),
        group: {
            id: 'sam',
            label: Loc.g('SAM'),
        },
        component: 'tab-listingv1',
        permission: 'can_edit',
        more: {
            tabType: 'total',
            callbackKeyName: 'tabContent',
            title: '',
            url: '/?_f=sellsyadmin_thirdaddon',
            action: 'loadAccountTab',
            corpid: '{corpid}',
            buttons: [],
        },
    },
    {
        id: 'samReferral',
        label: Loc.g('Parrainage'),
        group: {
            id: 'sam',
            label: Loc.g('SAM'),
        },
        component: 'tab-listingv1',
        permission: 'can_edit',
        more: {
            tabType: 'total',
            callbackKeyName: 'tabContent',
            title: '',
            url: '/?_f=sellsyadmin_thirdaddon',
            action: 'loadAffiliationTab',
            corpid: '{corpid}',
            buttons: [],
        },
    },
    {
        id: 'samQuota',
        label: Loc.g('Provisions - Quota'),
        group: {
            id: 'sam',
            label: Loc.g('SAM'),
        },
        component: 'tab-listingv1',
        permission: 'can_edit',
        more: {
            tabType: 'total',
            title: '',
            listingname: 'provision',
            url: '/?_f=tabs',
            action: 'loadListingTab',
            corpid: '{corpid}',
            context: 'third',
            prefilter: '{"corpid": "{corpid}"}',
            buttons: [],
        },
    },
    {
        id: 'samTerms',
        label: Loc.g('Conditions Générales'),
        group: {
            id: 'sam',
            label: Loc.g('SAM'),
        },
        component: 'tab-sam-terms-list',
        more: {
            url: '/rest/sellsy-account-manager/corporation/{corpid}/terms',
            corpid: '{corpid}',
            prefilter: '{"corpid": "{corpid}"}',
            buttons: [],
        },
        keepalive: false,
    },
];

// - SAM exclusive tabs
var samTabs = [
    {
        id: 'samCarts',
        label: Loc.g('Paniers'),
        group: {
            id: 'sam',
            label: Loc.g('SAM'),
        },
        component: 'tab-sam-carts-list',
        more: {
            url: '/rest/sellsy-account-manager/corporation/{corpid}/carts',
            corpid: '{corpid}',
            prefilter: '{"corpid": "{corpid}"}',
            buttons: [
                {
                    id: 'add',
                    type: 'vuejs',
                    label: Loc.g('Créer un panier'),
                    primary: true,
                    event: 'sam:cart:create',
                    permission: 'sam_can_create_cart',
                },
            ],
        },
        keepalive: false,
    },
];

var moreNav = [
    {
        id: 'connection',
        versions: [1, 2, 3, 4, 5],
        label: Loc.g('Connexion'),
        type: 'component',
        component: 'connection',
        coloredIcon: 'settings-star',
        data: {
            thirdid: '{linkedid}',
        },
    },
    {
        id: 'sellsyadmin',
        versions: [1, 2],
        label: Loc.g('SellsyAdmin'),
        type: 'component',
        component: 'corporation-data-v2',
        data: {
            thirdid: '{linkedid}',
        },
    },
    {
        id: 'sam',
        versions: [3, 4, 5],
        label: Loc.g('SAM'),
        type: 'component',
        component: 'corporation-data-v3',
        coloredIcon: 'user-hexagon',
        data: {
            canEditUtm: '{canEditUtm}',
            canManageThirdPayer: '{canManageThirdPayer}',
            canBlockUnblockAccount: '{canBlockUnblockAccount}',
            canDisableSalesCart: '{canDisableSalesCart}',
            canDisableSaasBilling: '{canDisableSaasBilling}',
            canDisableTrialImportLimit: '{canDisableTrialImportLimit}',
            canUnlinkCorp: '{canUnlinkCorp}',
            canSynchronizeDataOnThird: '{canSynchronizeDataOnThird}',
            canChurnCustomer: '{canChurnCustomer}',
            corporation: '{corpid}',
            thirdPayerId: '{thirdPayerId}',
            thirdPayerName: '{thirdPayerName}',
            displayTrialBanner: '{displayTrialBanner}',
            thirdId: '{thirdId}',
            maintenance: '{maintenance}',
        },
    },
];

var headerActions = [
    {
        label: Loc.g('Modifier la société'),
        type: 'js',
        value: 'javascript:Third.edit({id})',
        permission: 'can_edit',
    },
    {
        label: Loc.g('Supprimer la société'),
        type: 'js',
        value: "javascript:Third.deleteThird({id}, '{can_delete_people}', '{type}')",
        permission: 'can_delete',
    },
    {
        label: Loc.g("Compléter via l'annuaire"),
        type: 'js',
        value: 'javascript:CompanySearch.modalUpdate({id})',
        permission: 'can_edit',
        display: 'can_company_search',
    },
    {
        label: Loc.g('Archiver la société'),
        type: 'js',
        value: "javascript:Third.singleUpdateState({id}, 'N')",
        permission: 'can_edit',
        display: 'can_show_action_archive',
    },
    {
        label: Loc.g('Restaurer la société'),
        type: 'js',
        value: "javascript:Third.singleUpdateState({id}, 'Y')",
        permission: 'can_edit',
        display: 'can_show_action_unarchive',
    },
    {
        label: Loc.g('Transformer en prospect'),
        type: 'js',
        value: "javascript:Third.transformThird('prospect', {id}, '');",
        permission: 'can_transform_to_prospect',
        display: 'can_show_action_transform_to_prospect',
    },
    {
        label: Loc.g('Transformer en client'),
        type: 'js',
        value: "javascript:Third.transformThird('client', {id}, '');",
        permission: 'can_transform_to_client',
        display: 'can_show_action_transform_to_client',
    },
    {
        label: Loc.g('Transformer en société'),
        type: 'js',
        value: "javascript:Third.transformOneThirdType({id}, 'corporation');",
        permission: 'can_transform_to_third',
        display: 'can_show_action_transform_to_third',
    },
    {
        label: Loc.g('Télécharger la VCard'),
        type: 'js',
        value: "javascript:Utils.relocate('/?_f=third&action=vcard&thirdid={id}')",
        permission: true,
    },
    {
        label: Loc.g('Ajouter du score'),
        type: 'js',
        value: "javascript:ScoringEvent.addScore({id}, {main_tpcid}, '" + location.href + "');",
        permission: 'can_edit',
        display: 'can_add_prospection_score',
    },
    {
        label: Loc.g('Modifier le logo de la société'),
        type: 'function',
        value: 'uploadAvatar',
        permission: true,
    },
    {
        label: Loc.g("Envoyer les identifiants pour l'espace client"),
        type: 'js',
        value: 'javascript:Third.sendContactPwd({main_tpcid}, {id})',
        permission: 'can_create_sellsy_access',
        display: 'can_create_sellsy_access',
    },
    {
        label: Loc.g('Fermer son accès'),
        type: 'js',
        value: 'javascript:Third.closeThirdAccess({main_tpcid}, {id})',
        permission: 'can_remove_sellsy_access',
        display: 'can_remove_sellsy_access',
    },
    {
        label: Loc.g('Recevoir la liste des traitements'),
        type: 'js',
        value: "javascript:Third.exportRegister('third', '{id}');",
        permission: 'can_download_treatments_list_via_menu',
        display: 'can_download_treatments_list_via_menu',
    },
];

var contactsActions = [
    {
        label: Loc.g('Voir'),
        type: 'link',
        link: '/?_f=people&id={id}',
        permission: true,
    },
    {
        label: Loc.g('Modifier'),
        type: 'js',
        link: "javascript:People.edit('thirdOverview', {id})",
        permission: 'can_edit',
    },
    {
        label: Loc.g("Activer l'accès à l'espace client"),
        type: 'js',
        link: 'javascript:Third.openThirdAccess({contactid}, {linkedid})',
        permission: 'can_manage_access',
        hide: function (item) {
            return item.hasClientArea || !item.email;
        },
    },
    {
        label: Loc.g("Désactiver l'accès à l'espace client"),
        type: 'js',
        link: 'javascript:Third.closeThirdAccess({contactid}, {linkedid})',
        permission: 'can_manage_access',
        hide: function (item) {
            return !item.hasClientArea;
        },
    },
    {
        label: Loc.g('Définir en tant que contact principal'),
        type: 'vuejs',
        link: 'defineMainContact',
        permission: 'can_edit',
        display: 'can_show_define_main_contact',
        filter: function (item) {
            return !item.mainContact;
        },
    },
    {
        label: Loc.g('Définir en tant que contact de facturation'),
        type: 'vuejs',
        link: 'defineBillingContact',
        permission: 'can_edit',
        hide: function (item) {
            return item.billingContact;
        },
    },
    {
        label: Loc.g('Définir en tant que contact de relance'),
        type: 'vuejs',
        link: 'defineDunningContact',
        permission: 'can_edit',
        filter: function (item) {
            return !item.mainContactDunning;
        },
    },
    // {
    //     label: Loc.g("Envoyer les identifiants pour l'espace client"),
    //     type: "js",
    //     value: "javascript:Third.sendContactPwd('{contactid}')",
    //     permission: "can_edit"
    // },
    {
        label: Loc.g('Délier le contact'),
        type: 'js',
        link: "javascript:People.removeLinked('{id}', '{contactid}')",
        permission: 'can_edit',
    },
    {
        label: Loc.g('Supprimer'),
        type: 'js',
        link: "javascript:People.deleteOne('{id}', 'newoverview', '{csrfToken}');",
        permission: 'can_edit',
        hide: function (item) {
            return item.billingContact;
        },
    },
];

var mainContactsActions = [
    {
        label: Loc.g('Voir'),
        type: 'link',
        link: '/?_f=people&id={id}',
        permission: true,
    },
    {
        label: Loc.g('Modifier'),
        type: 'js',
        link: "javascript:People.edit('thirdOverview', {id})",
        permission: 'can_edit',
    },
    {
        label: Loc.g("Activer l'accès à l'espace client"),
        type: 'js',
        link: 'javascript:Third.openThirdAccess({contactid}, {linkedid})',
        permission: 'can_manage_access',
        hide: function (item) {
            return item.hasClientArea || !item.email;
        },
    },
    {
        label: Loc.g("Désactiver l'accès à l'espace client"),
        type: 'js',
        link: 'javascript:Third.closeThirdAccess({contactid}, {linkedid})',
        permission: 'can_manage_access',
        hide: function (item) {
            return !item.hasClientArea;
        },
    },
    {
        label: Loc.g('Définir en tant que contact de facturation'),
        type: 'vuejs',
        link: 'defineBillingContact',
        permission: 'can_edit',
        hide: function (item) {
            return item.billingContact;
        },
    },
    {
        label: Loc.g('Définir en tant que contact de relance'),
        type: 'vuejs',
        link: 'defineDunningContact',
        permission: 'can_edit',
        //display: "can_show_define_main_contact",
        filter: function (item) {
            return !item.mainContactDunning;
        },
    },
    {
        label: Loc.g('Délier le contact'),
        type: 'js',
        link: "javascript:People.removeLinked('{id}', '{contactid}')",
        permission: 'can_edit',
    },
];

var sellsyAdminContactActions = [
    {
        id: 'staffType',
        label: Loc.g('Changer type de staff'),
        type: 'group',
        link: '',
        permission: 'can_edit',
        childrens: [
            {
                label: Loc.g('Regular'),
                value: 'regular',
                type: 'js',
                link: "javascript:SellsyAdmin.updateStaffType('{staffid}', '{corpid}', 'regular')",
                disabled: false,
            },
            {
                label: Loc.g('Temporary'),
                value: 'temporary',
                type: 'js',
                link: "javascript:SellsyAdmin.updateStaffType('{staffid}', '{corpid}', 'temporary')",
                disabled: false,
            },
            {
                label: Loc.g('Sellsy'),
                value: 'sellsy',
                type: 'js',
                link: "javascript:SellsyAdmin.updateStaffType('{staffid}', '{corpid}', 'sellsy')",
                disabled: false,
            },
        ],
    },
    {
        id: 'isDecisionMaker',
        label: Loc.g('Est décisionnaire'),
        type: 'js',
        link: 'javascript:SellsyAdmin.staffEnableAsDecisionMaker({corpid},{staffid})',
        permission: 'can_edit',
        filter: function (item) {
            return item.sellsyadmin.staff_status == 'ok';
        },
    },
    {
        id: 'isNotDecisionMaker',
        label: Loc.g("N'est pas décisionnaire"),
        type: 'js',
        link: 'javascript:SellsyAdmin.staffDisableAsDecisionMaker({corpid},{staffid})',
        permission: 'can_edit',
        filter: function (item) {
            return item.sellsyadmin.staff_status == 'ok';
        },
    },
    {
        id: 'blockStaff',
        label: Loc.g('Bloquer le staff'),
        type: 'js',
        link: "javascript:SellsyAdmin.updateStaffStatus({corpid}, {staffid}, 'blocked')",
        permission: 'can_edit',
    },
    {
        id: 'unblockStaff',
        label: Loc.g('Débloquer le staff'),
        type: 'js',
        link: "javascript:SellsyAdmin.updateStaffStatus({corpid}, {staffid}, 'ok')",
        permission: 'can_edit',
    },
    {
        id: 'changeCorpOwner',
        label: Loc.g('Définir comme propriétaire du compte Sellsy'),
        type: 'vuejs',
        link: 'defineAsCorporationOwner',
        permission: ['can_edit', 'can_manage_corporation_owner'],
        filter: function (item) {
            return item.sellsyadmin.staff_status == 'ok';
        },
    },
];

var addressesActions = [
    {
        label: Loc.g('Modifier'),
        type: 'vuejs',
        emitBus: false,
        link: 'openAddress',
        permission: 'can_edit_addresses',
    },
    {
        label: Loc.g("Définir en tant qu'adresse de facturation"),
        type: 'vuejs',
        link: 'defineInvoicingAddress',
        permission: 'can_edit_addresses',
        filter: function (item) {
            return !item.isMainInvoicingAddress;
        },
    },
    {
        label: Loc.g("Définir en tant qu'adresse de livraison"),
        type: 'vuejs',
        link: 'defineDeliveryAddress',
        permission: 'can_edit_addresses',
        filter: function (item) {
            return !item.isMainDeliveryAddress;
        },
    },
    {
        label: Loc.g('Supprimer'),
        type: 'vuejs',
        link: 'deleteItem',
        permission: 'can_delete_addresses',
    },
];

var bankActions = [
    {
        id: 'edit', // Modifier le RIB
        label: Loc.g('Modifier'),
        type: 'js',
        link: "javascript:BankAccount.edit({baid}, 'third', {thirdid})",
        permission: 'can_edit_rib',
    },
    {
        id: 'delete',
        label: Loc.g('Supprimer'), // Supprimer le RIB
        type: 'js',
        link: 'javascript:BankAccount.deleteOne({baid})',
        permission: 'can_delete_rib',
    },
    {
        id: 'defineMainAccount',
        label: Loc.g('Définir en tant que compte principal'),
        type: 'vuejs',
        link: 'defineMainAccount',
        permission: true,
    },
    {
        id: 'add_card', // Ajouter une carte bancaire
        permission: 'can_add_card',
    },
    {
        id: 'delete_card', // Supprimer une carte bancaire
        permission: 'can_delete_card',
    },
];

var backlink = [
    {
        type: 'client',
        url: '/thirds/client',
        label: Loc.g('Sociétés'),
    },
    {
        type: 'prospect',
        url: '/thirds/prospect',
        label: Loc.g('Sociétés'),
    },
    {
        type: 'supplier',
        url: '/thirds/supplier',
        label: Loc.g('Sociétés'),
    },
];

var routes = [
    {
        id: 'favorite',
        value: '/rest/thirds/{type}/overviews/favorites',
    },
    {
        id: 'activityform',
        value: '/rest/thirds/{id}/activity',
    },
    {
        id: 'save',
        value: '/rest/thirds/{id}/{type}',
    },
    {
        id: 'bank',
        value: '/rest/thirds/{id}/bankingdatas',
    },
];

var object = {
    idName: 'thirdid',
};

var agendaViewConfig = {
    relatedtype: 'third',
    nameCallbackFunction: 'Third.loadAgendaTab',
    prefixXsl: 'third',
};

const systemPaydatesWithEndOfMonth = ['30days', '45days', '60days', '90days'];

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    sellsyAdminContactActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    // SellsyAdmin
    sellsyAdminCommonTabs,
    samTabs,
    agendaViewConfig,
    systemPaydatesWithEndOfMonth,
};
